// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbh_a bhp_i bhp_j","ColorVariants__color":"bbh_b bhp_rp","ColorVariants__more":"bbh_c bhp_vv"};